/* eslint-disable promise/param-names */
const state = {
  grid:{
      url: '',
      title: '',
      columns: {},
      show: false,
      titleHelp: '',
      txtHelp: '',
      totalDados: '',
  }
}

const getters = {
  grid: state => state.grid,
}

const mutations = {
    changeGrid(state, payload){
        state.grid = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/grid.js